import { gql } from '@apollo/client';

import {
  AddFormMessagePreviewDocument,
  type AddFormMessagePreviewMutation,
  type AddFormMessagePreviewMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddFormMessagePreview($input: AddFormMessagePreviewInput!) {
      addFormMessagePreview(input: $input) {
        message {
          id
          text
          createdAt
          sender
          transcript
          contentUrl
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
        }
        surveyProgress
      }
    }
  `;
}

export const ADD_FORM_MESSAGE_PREVIEW = AddFormMessagePreviewDocument;
export type {
  AddFormMessagePreviewMutation,
  AddFormMessagePreviewMutationVariables,
};
